'use client';

import { configureStore } from '@reduxjs/toolkit';
import { useState, type ReactNode } from 'react';
import { Provider } from 'react-redux';

import { authPanelReducer } from '@/features/auth-by-phone';
import { siteMenuReducer } from '@/features/site-menu';

// Global UI only: overlays that are opened from several places. Server data lives in TanStack Query.
export function makeStore() {
  return configureStore({
    reducer: { siteMenu: siteMenuReducer, authPanel: authPanelReducer },
    devTools: process.env.NODE_ENV !== 'production',
  });
}

export function StoreProvider({ children }: { children: ReactNode }) {
  const [store] = useState(makeStore);
  return <Provider store={store}>{children}</Provider>;
}
